import { setStorage, getStorage, clearStorage } from "@/utils/localStorageLib";

const ticketKet = "etms_ticketKet";

export function setWxTicket(mykey) {
  clearStorage(ticketKet);
  setStorage(ticketKet, mykey);
}

export function getWxTicket() {
  var mykey = getStorage(ticketKet);
  // clearStorage(ticketKet);
  return mykey;
}



// WEBPACK FOOTER //
// ./src/utils/wxTicket.js